module.exports = __webpack_public_path__ + "img/attack_smallDarkmagic.aaaeb269.png";